export default __webpack_public_path__ + "c95087e1a852cf730acc3defc2d52724.svg";